export default "__VITE_ASSET__B60axvBY__"